import { Component } from '@angular/core';

@Component({
    selector: 'vb-ad-card',
    templateUrl: './vb-ad-card.component.html',
    styleUrls: ['./vb-ad-card.component.scss'],
})
export class VbAdCardComponent {}
